/* global axios */
import ApiClient from './ApiClient';

const newIdempotencyKey = () => {
  const requestId = window.crypto?.randomUUID?.();
  const fallbackId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  return `whatsapp-call:${requestId || fallbackId}`;
};

class WhatsappCallsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  start(conversationId, connectionId, idempotencyKey, options = {}) {
    const requestIdempotencyKey = idempotencyKey || newIdempotencyKey();

    const payload = {
      connection_id: connectionId,
      idempotency_key: requestIdempotencyKey,
    };
    if (options.video === true) payload.video = true;
    if (options.groupId) payload.group_id = options.groupId;
    if (Array.isArray(options.targets) && options.targets.length) {
      payload.targets = options.targets;
    }
    if (options.callLink) payload.call_link = options.callLink;
    return axios.post(`${this.url}/${conversationId}/whatsapp_calls`, payload, {
      headers: { 'Idempotency-Key': requestIdempotencyKey },
    });
  }

  startTest(payload, idempotencyKey) {
    const requestIdempotencyKey =
      idempotencyKey || payload.idempotency_key || newIdempotencyKey();

    return axios.post(
      `${this.baseUrl()}/whatsapp_call_tests`,
      { ...payload, idempotency_key: requestIdempotencyKey },
      { headers: { 'Idempotency-Key': requestIdempotencyKey } }
    );
  }

  getCall(callId) {
    return axios.get(`${this.baseUrl()}/whatsapp_calls/${callId}`);
  }

  performAction(callId, action, payload = {}) {
    return axios.post(
      `${this.baseUrl()}/whatsapp_calls/${callId}/${action}`,
      payload
    );
  }

  getCallGateway(connectionId) {
    return axios.get(
      `${this.baseUrl()}/lais_whatsapp_connections/${connectionId}/call_gateway`
    );
  }

  listConnections() {
    return axios.get(`${this.baseUrl()}/lais_whatsapp_connections`);
  }

  updateCallGateway(connectionId, payload = {}) {
    return axios.put(
      `${this.baseUrl()}/lais_whatsapp_connections/${connectionId}/call_gateway`,
      payload
    );
  }

  callLink(connectionId, action, payload = {}) {
    return axios.post(
      `${this.baseUrl()}/lais_whatsapp_connections/${connectionId}/call_links`,
      { link_action: action, ...payload }
    );
  }
}

export default new WhatsappCallsAPI();
